import { useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import {
  apiVersion,
  customerName,
  backendUrl,
} from "../../constants/constants";
import {
  CircularProgress,
  ToggleButton,
  ToggleButtonGroup,
  useTheme,
} from "@mui/material";

const AccessToggleButton = ({
  userName,
  applicationId,
  token,
  handleAlert,
  handleRender,
}) => {
  const { t } = useTranslation();
  const [alignment, setAlignment] = useState("left");
  const [revokeLoading, setRevokeLoading] = useState(false);
  const [grantLoading, setGrantLoading] = useState(false);
  const theme = useTheme();

  const handleAlignment = (newAlignment) => {
    setAlignment(newAlignment);
  };

  const handleRevokePermission = async () => {
    setRevokeLoading(true);
    const apiUrl = `${backendUrl}/${apiVersion}/rewokeAssignments`;
    const postData = [
      {
        appId: applicationId,
        userId: userName,
      },
    ];
    const stringifyData = JSON.stringify(postData);
    try {
      const response = await axios.post(apiUrl, stringifyData, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          customerName: customerName,
          applicationId: applicationId,
        },
      });
      response.status && handleAlert(true, "warning");
    } catch (error) {
      console.log("something went wrong in revoke access:", error);
    } finally {
      setRevokeLoading(false);
      handleRender();
    }
  };

  const handleGrantPermission = async () => {
    try {
      setGrantLoading(true);
      const apiUrl = `${backendUrl}/${apiVersion}/grantNewAssignments`;
      const response = await axios.post(
        apiUrl,
        [
          {
            grantAccessTo: userName,
          },
        ],
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            customerName: customerName,
            applicationId: applicationId,
          },
        }
      );
      response.status === 200 && handleAlert(true);
    } catch (error) {
      console.log("error in grant access:", error);
    } finally {
      setGrantLoading(false);
      handleRender();
    }
  };
  return (
    <ToggleButtonGroup
      value={alignment}
      exclusive
      onChange={handleAlignment}
      aria-label="text alignment"
      sx={{
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
          marginTop: "16px",
        },
      }}
    >
      <ToggleButton
        value="left"
        aria-label="left aligned"
        sx={{
          height: 50,
          fontSize: 12,
          padding: "16px 32px",
        }}
        onClick={handleRevokePermission}
      >
        {revokeLoading ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          t("buttons.revoke")
        )}
      </ToggleButton>
      <ToggleButton
        value="right"
        aria-label="centered"
        sx={{
          height: 50,
          fontSize: 12,
          padding: "16px 32px",
        }}
        onClick={handleGrantPermission}
      >
        {grantLoading ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          t("buttons.extend")
        )}
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default AccessToggleButton;
